require('./stylesheet/index.scss');

angular.module('pages.payment', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.payment', {
			url: 'payment/:url',
			template: require('./templates/index.html'),
			controller: require('./controllers/payment'),
			data: {
				iframe: true
			},
			params: {
				fields: {},
				createFields: {},
				toEvent: null,//event to go to(for direct link to event) exmpl:pages.payment({url:configs.payments_config.service.metallist, toEvent:32776496})
				serviceId: null,
				hh: {
					templateId: null,
					serviceName: null,
					streetName: null
				},
				hhTemplate: false,
				autoCheck: null,
				subscribe: null,
				amount: null,
				counters: null,
				account: null,
				lastDate: null,
				destination: null,
				templateId: null,
                urlCode: null,
				editForbid: false,
				infoState: '',
				notify: {
					type: null,
					mssg: null
				}
			},
			pageTrack: '/payment'
		})
}

module.exports = 'pages.payment';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/payment/index.js
 ** module id = 281
 ** module chunks = 1
 **/